<div class="topbar-action-buttons-container">
	<div class="ai-chat-ask-me">{{ 'ask_me' | translate }}</div>
	@if (isAiChatEnabled()) {
		<div class="ai-chat-icon" matRipple (click)="openAiChat()">
			<mat-icon svgIcon="normal-robot" [class.active]="isAiChatOpened()" />
		</div>
	}
</div>
